'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { drawMonogram } from '@/utils/design-elements';
import { formatClassName, getPageName, normalizePath } from '@/utils/helpers';
import { drawIcon, socialLinks } from '@/utils/social-buttons';
interface FooterLinkItem {
  readonly label: string;
  readonly link: string;
}
const footerButtonLinks: readonly FooterLinkItem[] = [{
  label: 'About',
  link: '/about'
}, {
  label: 'Donate',
  link: '/donate/uk'
}];
const footerLegalAndUtilityLinks: readonly FooterLinkItem[] = [{
  label: 'Privacy Policy',
  link: '/privacy'
}
// { label: "Terms", link: "/terms" },
];

// eslint-disable-next-line max-lines-per-function
export default function BottomAppBar() {
  const $ = _c(26);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = getPageName(pathname) === "" ? "home" : getPageName(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const pageName = t0;
  let t1;
  if ($[2] !== pathname) {
    t1 = footerButtonLinks.map((item, index) => <li className={formatClassName(item.link)} key={index}><Link href={item.link} aria-current={normalizePath(pathname) === normalizePath(item.link) ? "page" : undefined}>{item.label}</Link></li>);
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="bottom-app-bar-cell bottom-app-bar-cell-nav"><ul className="footer-links">{t1}</ul></div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bottom-app-bar-cell bottom-app-bar-cell-social"><ul className="social follow-buttons" data-label="Connect with us on social media">{socialLinks.map(_temp)}</ul></div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/?ref=chooser-v1" rel="noreferrer" target="_blank">Creative Commons License</a>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <dt>The Future Found Registration:</dt>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <dl className="organization-registration-details">{t5}<dd>In aid of GivingWorks, Charity Number{" "}{process.env.NEXT_PUBLIC_ORGANIZATION_CHARITY_NUMBER || "1078770"}.{" "}</dd></dl>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== pathname) {
    t7 = footerLegalAndUtilityLinks.map((item_0, index_0) => <li key={index_0}><Link href={item_0.link} aria-current={normalizePath(pathname) === normalizePath(item_0.link) ? "page" : undefined}>{item_0.label}</Link></li>);
    $[10] = pathname;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <div className="copyright-sign-off-device-cell copyright-sign-off-device-cell-fine-print">The Future Found Inc. is licensed under a{" "}{t4}.{" "}{t6}<ul className="fine-print-links">{t7}</ul></div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = normalizePath(pathname) === normalizePath("/") ? "page" : undefined;
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = drawMonogram({
      size: 512
    });
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t9) {
    t11 = <div className="copyright-sign-off-device-cell copyright-sign-off-device-cell-monogram"><Link aria-current={t9} aria-label="Link to the home page" href="/">{t10}</Link></div>;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t8) {
    t12 = <div className="bottom-app-bar-cell bottom-app-bar-cell-fine-print"><div className="copyright-sign-off-device">{t8}{t11}</div></div>;
    $[17] = t11;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t2) {
    t13 = <div className="bottom-app-bar">{t2}{t3}{t12}</div>;
    $[20] = t12;
    $[21] = t2;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== pageName || $[24] !== t13) {
    t14 = <div className="footer" data-color-scheme="neon-rose" data-page-name={pageName}>{t13}</div>;
    $[23] = pageName;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}
function _temp(link) {
  return <li className={link.group_id} key={link.group_id}><a aria-label={`Follow us on ${link.displayName}`} className="gtm-join-group" data-gtm-param-group-id={link.group_id} href={link.href} rel="nofollow noreferrer" role="button" target="_blank" title={link.displayName}>{drawIcon(link.group_id)}</a></li>;
}